// import Splide from "@splidejs/splide";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "@splidejs/splide/css";

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { FaRegCalendarAlt } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { getContactOfficeData, getHomeData, getNewsData } from "../api/home";
import TabContent from "../components/TabContent";
import "../styles/home.css";
import { formatThaiDateShort, toImagePath } from "../utils/globalFunctions";
import { use } from "react";

export const tabs = [
  {
    label: "ข่าวสาร",
    value: "news",
  },
  {
    label: "กิจกรรม",
    value: "event",
  },
  {
    label: "Cybersecurity Knowledge",
    value: "knowledge",
  },
  {
    label: "NCSA Cyber Clinic",
    value: "clinic",
  },
  {
    label: "Youtube VDO",
    value: "youtube",
  },
  {
    label: "Uncategorized",
    value: "other",
  },
];

function HomePage() {
  const [banners, setBanners] = useState([]);
  const [aboutsData, setAboutsData] = useState(null);

  const getData = useCallback(async () => {
    try {
      const response = await getHomeData();

      const bns = response.section1.banners.map((bn) => {
        return {
          img: toImagePath(bn.bannerimage.path),
          headline1: bn.banner_row1,
          headline2: bn.banner_row2,
          headline3: bn.banner_row3,
        };
      });

      setBanners(bns);

      const abts = {
        head: response.section2.head,
        content: response.section2.content,
        buttonlink: response.section2.buttonlink,
        images: response.section2.section2image
          .slice(0, 4)
          .map((img) => toImagePath(img.path)),
      };
      setAboutsData(abts);

    } catch (error) {
      console.warn(error);
    }
  }, [setAboutsData, setBanners]);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <main className="site-main">
      <BannerContent heroImages={banners} />
      <AboutNCSA data={aboutsData} />
      <NewsContent />
      <TabsNewsContent />

      <GMapSection />
    </main>
  );
}

export default HomePage;

const BannerContent = ({ heroImages = [] }) => {
  // const heroImages = [
  //   {
  //     img: "/images/hero-image.jpeg",
  //     headline1: "สำนักงานคณะกรรมการรักษาความมั่นคงปลอดภัย",
  //     headline2: "ไซเบอร์แห่งชาติ",
  //     headline3: "Nation Cyber Security Agency - NCSA",
  //   },
  //   {
  //     img: "/images/hero-image.jpeg",
  //     headline1: "สำนักงานคณะกรรมการรักษาความมั่นคงปลอดภัย",
  //     headline2: "ไซเบอร์แห่งชาติ",
  //     headline3: "Nation Cyber Security Agency - NCSA",
  //   },
  //   {
  //     img: "/images/hero-image.jpeg",
  //     headline1: "สำนักงานคณะกรรมการรักษาความมั่นคงปลอดภัย",
  //     headline2: "ไซเบอร์แห่งชาติ",
  //     headline3: "Nation Cyber Security Agency - NCSA",
  //   },
  // ];

  // useEffect(() => {
  //   const splideElement = document.querySelector(".splide");

  //   const paginationElement = splideElement.querySelector(
  //     ".splide__pagination"
  //   );
  //   if (paginationElement) {
  //     paginationElement.remove();
  //   }

  //   new Splide("#hero_splide", {
  //     type: "loop",
  //     rewind: true,
  //     pagination: true,
  //     arrows: true,
  //     perPage: 1,
  //     classes: {
  //       arrows: "splide__arrows hero-splide__arrows",
  //       arrow: "splide__arrow hero-splide__arrow",
  //       prev: "splide__arrow--prev hero-splide__prev",
  //       next: "splide__arrow--next hero-splide__next",
  //       pagination: "splide__pagination hero-splide__pagination",
  //       page: "splide__pagination__page hero-splide__page",
  //     },
  //   }).mount();

  //   setTimeout(() => {
  //     new Splide("#news_splide", {
  //       type: "loop",
  //       arrows: true,
  //       gap: 30,
  //       padding: "8rem",
  //       pagination: false,
  //       perPage: 3,
  //       perMove: 3,
  //       speed: 500,
  //       classes: {
  //         arrows: "splide__arrows news-splide__arrows",
  //         arrow: "splide__arrow news-splide__arrow",
  //         prev: "splide__arrow--prev news-splide__prev",
  //         next: "splide__arrow--next news-splide__next",
  //         pagination: "splide__pagination news-splide__pagination",
  //         page: "splide__pagination__page news-splide__page",
  //       },
  //       breakpoints: {
  //         960: {
  //           perPage: 1,
  //           perMove: 1,
  //           gap: 20,
  //           padding: "4rem",
  //         },
  //       },
  //     }).mount();
  //   }, 1000);
  // }, []);

  // return (
  //   <section
  //     id="hero_splide"
  //     className="splide"
  //     aria-label="Splide Basic HTML Example"
  //   >
  //     <div className="splide__track">
  //       <ul className="splide__list">
  //         {heroImages.map((item, index) => (
  //           <li key={index} className="splide__slide">
  //             <img
  //               className="img-cover h-screen w-screen"
  //               src={item.img}
  //               alt="heroImageNCSA"
  //             />
  //             <div className="img-content-center">
  //               <div className="header">
  //                 <div className="headline text-md md:text-md">
  //                   {item.headline1}
  //                 </div>
  //                 <div className="headline text-xl md:text-xl pt-2">
  //                   {item.headline2}
  //                 </div>
  //                 <div className="headline text-md md:text-sm">
  //                   <small>{item.headline3}</small>
  //                 </div>
  //               </div>
  //             </div>
  //           </li>
  //         ))}
  //       </ul>
  //     </div>
  //   </section>
  // );

  return (
    <section>
      <Splide aria-label="My Favorite Images">
        {heroImages.map((item, index) => {
          return (
            <SplideSlide key={index}>
              <div className="relative">
                <img
                  src={item.img}
                  alt={`banner-${index + 1}`}
                  className="w-screen h-screen object-cover"
                />
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                  <div className="text-3xl text-white text-center drop-shadow-lg">
                    {item.headline1}
                  </div>
                  <div className="text-6xl text-white text-center my-5 drop-shadow-lg">
                    {item.headline2}
                  </div>
                  <div className="text-xl text-white text-center">
                    {item.headline3}
                  </div>
                </div>
              </div>
            </SplideSlide>
          );
        })}
      </Splide>
    </section>
  );
};

const AboutNCSA = ({ data }) => {
  const { t } = useTranslation();

  return (
    <section className="bg-white relative">
      <img
        className="img-background"
        src="/images/bg-map.png"
        role="presentation"
        alt="ncsa"
      />
      <div className="container mx-auto py-4 relative z-10">
        <div className="md:flex md:flex-auto h-full p-4">
          <div className="w-full md:w-[50%]">
            <div className="w-full h-full flex items-center justify-center">
              <div className="p-4">
                <h1 className="text-4xl font-bold mb-4">
                  <span className="inline-block text-[var(--base-color)]">
                    {t("about")}
                  </span>
                  <span className="inline-block ml-2 text-[var(--secondary-color)]">
                    {/* {data?.head} */}
                    {t("ncsa")}
                  </span>
                </h1>
                <div dangerouslySetInnerHTML={{ __html: data?.content }} />

                <div className="py-4">
                  <Link to="/about" className="button-red-main text-md">
                    {t("viewMore")}
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full md:w-[50%]">
            <div className="columns-2 gap-0">
              {data?.images?.map((img) => {
                return (
                  <img className="photo-rounded-shadow" src={img} alt="ncsa" />
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const NewsContent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [news, setNews] = useState([]);

  function NextArrow(props) {
    const { onClick } = props;

    if (!onClick) return null;

    return (
      <div
        onClick={onClick}
        style={{
          display: "block",
          background: "red",
          position: "absolute",
          right: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          padding: "10px",
          borderRadius: "50%",
          zIndex: 5,
        }}
      >
        <BiChevronRight color="white" size="30px" />
      </div>
    );
  }

  function PrevArrow(props) {
    const { onClick } = props;

    // console.log("PrevArrow", props);

    if (!onClick) return null;

    return (
      <div
        onClick={onClick}
        style={{
          display: "block",
          background: "red",
          position: "absolute",
          left: "20px",
          top: "50%",
          transform: "translateY(-50%)",
          padding: "10px",
          borderRadius: "50%",
          zIndex: 5,
        }}
      >
        <BiChevronLeft color="white" size="30px" />
      </div>
    );
  }

  const settings = {
    className: "slider variable-width",
    dots: true,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  const fetchNews = useCallback(async (category) => {
    try {
      const res = await getNewsData();

      const filteredData = res
        .filter((item) => item.category.includes(category))
        .sort((a, b) => b._created - a._created);

      const mapData = filteredData.map((item) => {
        return {
          ...item,
          image: toImagePath(item?.newsimage?.path),
        };
      });

      setNews(mapData);
    } catch (err) {
      console.warn(err);
    }
  }, []);

  useEffect(() => {
    fetchNews("announcement");
  }, [fetchNews]);

  return (
    <section className="bg-white relative">
      <div className="before-intro-section">
        <img src="/images/bg-intro-start.png" alt="" role="presentation" />
      </div>
      <div className="container mx-auto relative z-10">
        <div className="flex items-center justify-center py-6">
          <div className="intro-section">
            <div className="intro-section__logo">
              <img src="/images/logo-color-brand.png" alt="ncsa" />
            </div>
            <h2 className="intro-section__header">
              <span className="text-xl md:text-2xl">
                สำนักงานคณะกรรมการรักษาความมั่นคงปลอดภัย
              </span>
              <span className="text-3xl md:text-6xl">ไซเบอร์แห่งชาติ</span>
              <span className="text-md md:text-xl">
                National Cyber Security Agency - NCSA
              </span>
            </h2>
          </div>
        </div>
      </div>
      <div className="container mx-auto relative z-10">
        <div className="flex items-center justify-between px-4 md:px-0 py-4">
          <h3 className="text-2xl text-[var(--black-color)] font-semibold">
            ประกาศสำคัญ
          </h3>
          <Link
            to="/news?category=announcement"
            className="button-red-main text-md"
          >
            {t("viewAll")}
          </Link>
        </div>
      </div>

      <div className="my-2 slider-container ">
        <Slider {...settings} centerPadding="30px">
          {[...news].map((item) => (
            <div
              className="p-5 cursor-pointer z-10"
              key={item._id}
              onClick={() => navigate(`/news/${item._id}`)}
            >
              <div
                className=" bg-white rounded-lg shadow-md p-4"
                style={{
                  width: "400px",
                }}
              >
                <div>
                  <img
                    src={item.image}
                    alt="portfolio"
                    className="h-[200px] w-full object-cover rounded-lg"
                  />
                </div>

                <div className="mt-4 h-[100px]">
                  <div className="flex items-center">
                    <FaRegCalendarAlt />
                    <div>{formatThaiDateShort(item?._created)}</div>
                  </div>
                  <div className="limit-line-2 text-black">{item.title}</div>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <span className="block p-20" role="presentation" />
      <div className="after-intro-section">
        <img src="/images/bg-intro-end.png" alt="" role="presentation" />
      </div>
    </section>
  );
};

const TabsNewsContent = () => {
  const [activeNewsTab, setActiveNewsTab] = useState("news");
  const [news, setNews] = useState([]);

  const newsFilter = useMemo(() => {
    return (
      news
        .filter((item) => item.category.includes(activeNewsTab))
        .slice(0, 5) ?? []
    );
  }, [news, activeNewsTab]);

  const fetchNews = useCallback(async () => {
    try {
      const res = await getNewsData();

      const filteredData = res.sort((a, b) => b._created - a._created);

      const mapData = filteredData.map((item) => {
        return {
          ...item,
          image: toImagePath(item?.newsimage?.path),
          title: item.title,
          datetime: item._created,
          url: `/news/${item._id}`,
        };
      });

      setNews(mapData);
    } catch (err) {
      console.warn(err);
    }
  }, []);
  // const filteredTabs = [];
  const [filteredTabs, setFilteredTabs] = useState([]);
  const filterTabsBySectionOptions = (tabs, sectionOptions) => {
  let temp = tabs.filter((tab) => {
    const isIncluded = sectionOptions.includes(tab.value);
    return isIncluded; // ต้อง return ค่าที่เป็น true หรือ false
  });
  return temp;
  };
  const getData = useCallback(async () => {
    try {
      const response = await getHomeData();
      const section4optionTemp = response.section4option;
      setFilteredTabs(filterTabsBySectionOptions(tabs, section4optionTemp));
    } catch (error) {
      console.warn(error);
    }
  });


  useEffect(() => {
    fetchNews();
  }, [fetchNews]);
  useEffect(() => {
    getData();
  }, []);
  return (
    <section className="tab-news-container">
      <img
        className="img-background"
        src="/images/bg-news.png"
        alt=""
        role="presentation"
      />
      <div className="container mx-auto relative z-10">
        <div className="tabs-news">
          {filteredTabs.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setActiveNewsTab(tab.value)}
              className={`tab-news-button text-lg ${
                activeNewsTab === tab.value ? "active" : ""
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="tab-news-content">
          <TabContent items={newsFilter} currentTab={activeNewsTab} />
        </div>
      </div>
    </section>
  );
};

const GMapSection = () => {
  const [footerData, setFooterData] = useState("");
  const getData = useCallback(async () => {
    try {
      const response = await getContactOfficeData();

      setFooterData(response);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  useEffect(() => {
    getData();
  }, [getData]);

  return (
    <section>
      <div dangerouslySetInnerHTML={{ __html: footerData?.mapiframe }} />
    </section>
  );
};
